module.exports = __webpack_public_path__ + "img/Class-C-Desktop.710fb82f.jpg";